import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Id, MobileListRenderItemInfo } from 'drf-react-by-schema';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';

import { Layout } from 'src/styles';
import { MesocarpoProcessingStatus, ProcessingKey } from 'src/constants';

import AsmubipButton from './AsmubipButton';
import StatusChip from './StatusChip';

const MODEL = 'mesocarpo_processing';

export default function MesocarpoProcessingCard({
  item,
  id,
  entrepostoId,
}: MobileListRenderItemInfo & { entrepostoId?: Id }) {
  const navigate = useNavigate();
  const status = item.status.value.value as MesocarpoProcessingStatus;
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent sx={Layout.productionCardContent}>
        <Box sx={Layout.productionCardIconWrapper}>
          {status === MesocarpoProcessingStatus.COMPLETE ? (
            <CheckIcon sx={Layout.productionCardIcon} />
          ) : (
            <PauseIcon sx={Layout.productionCardIcon} />
          )}
        </Box>
        <Box>
          <Box>Lote {item.lote.valueStr}</Box>
          {item.pctes_um_quart && parseInt(item.pctes_um_quart.valueStr || '0') > 0 && (
            <Box>{item.pctes_um_quarto.valueStr} pacotes de 250g</Box>
          )}
          {item.pctes_metade && parseInt(item.pctes_metade.valueStr || '0') > 0 && (
            <Box>{item.pctes_metade.valueStr} pacotes de 250g</Box>
          )}
          {!entrepostoId && (
            <>
              <Box sx={{ color: (theme) => theme.palette.primary.main }}>
                {item.entreposto.valueStr}
              </Box>
              <Box>{item.municipio.valueStr}</Box>
            </>
          )}
          {item.data_processamento && <Box>Processado em {item.data_processamento.valueStr}</Box>}
          {item.data_empacotamento && <Box>Empacotado em {item.data_processamento.valueStr}</Box>}
          {item.comunidade && (
            <Box>
              <Typography variant="caption">{item.comunidade.valueStr}</Typography>
            </Box>
          )}
          <StatusChip type={ProcessingKey.MESOCARPO} status={status} />
        </Box>
      </CardContent>
      <CardActions>
        {status === MesocarpoProcessingStatus.COMPLETE ? (
          <Box sx={Layout.productionCardActionWrapper}>
            <AsmubipButton
              variant="outlined"
              size="large"
              sx={Layout.productionCardActionSingle}
              onClick={() => {
                navigate(`/${MODEL}/view/${id}`);
              }}>
              Ver detalhes
            </AsmubipButton>
            {/* <AsmubipButton
              variant="contained-dark"
              size="medium"
              startIcon={<WhatsAppIcon sx={{ color: 'inherit' }} />}>
              Compartilhar
            </AsmubipButton> */}
          </Box>
        ) : (
          <AsmubipButton
            variant="contained-dark"
            size="large"
            sx={Layout.productionCardActionSingle}
            onClick={() => {
              navigate(`/${MODEL}/edit/${id}`);
            }}>
            Editar
          </AsmubipButton>
        )}
      </CardActions>
    </Card>
  );
}
